import {ObjectId} from 'bson';
import {ObjectIdSchema} from '../../zod';
import {ApiDefinition, BatchedApiDefinition} from '../definitions';
import {z} from 'zod';
import {UnsyncedCountRequestSchema} from '../responses';

export const GetScoringInfo = {
  path: 'scoredAccounts/scoringInfo',
  method: 'get',
  options: {access: 'all'},
  requestDataSchema: z.object({}),
  responseDataSchema: z.object({
    runningRefresh: z
      .object({
        timestamp: z.date(),
        activeMarketId: ObjectIdSchema.optional(),
      })
      .optional(),

    latestRefresh: z
      .object({
        timestamp: z.date(),
        runId: ObjectIdSchema,
        activeMarketId: ObjectIdSchema,
      })
      .optional(),
  }),
} satisfies ApiDefinition;

export const RefreshAccounts = {
  path: 'refreshAccounts',
  method: 'post',
  options: {access: 'all'},
  requestDataSchema: z.object({activeMarketId: ObjectIdSchema.optional()}),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const GetScoredAccounts = {
  path: 'scoredAccounts',
  method: 'get',
  options: {access: 'all'},
  requestDataSchema: z.object({
    query: z.unknown().optional(),
    cursor: z.string().optional(),
  }),
  responseDataSchema: z.unknown(),
} satisfies ApiDefinition;

const DynamicListMembershipItemSchema = z.object({
  accountId: ObjectIdSchema,
});
type DynamicListMembershipItem = z.infer<
  typeof DynamicListMembershipItemSchema
>;

export const GetDynamicListMembership: BatchedApiDefinition<
  {accountIds: ObjectId[]},
  Record<string, ObjectId[]>,
  DynamicListMembershipItem,
  ObjectId[]
> = {
  path: 'scoredAccounts/dynamicListMembership',
  method: 'get',
  options: {access: 'all'},
  requestDataSchema: z.object({
    accountIds: z.array(ObjectIdSchema),
  }),
  responseDataSchema: z.record(z.string(), z.array(ObjectIdSchema)),
  itemSchema: DynamicListMembershipItemSchema,
  itemResponseDataSchema: z.array(ObjectIdSchema),

  createParams: (items) => ({
    accountIds: items.map((i) => i.accountId),
  }),
  resolveItem: (membership, item) =>
    membership[item.accountId.toString()] ?? [],
};

export const GetUnsyncedCount = {
  path: 'scoredAccounts/unsyncedCount',
  method: 'get',
  options: {access: 'paid'},
  requestDataSchema: UnsyncedCountRequestSchema,
  responseDataSchema: z.object({unsyncedCount: z.number()}),
} satisfies ApiDefinition;
